import React, { ReactNode, useCallback } from 'react';
import { Upload, UploadFile } from 'antd';
import { Colors } from '@common/tokens';
import { UploadChangeParam } from 'antd/lib/upload/interface';
import { useDocumentPreviewModalDeprecated } from '@common/components/document-preview-modal';

export const InlineFileUploaderInput = ({
  instruction,
  multiple,
  onChange,
  value,
}: {
  instruction: ReactNode;
  multiple?: boolean;

  // NOTE: antd's Form.Item injects the child's `value` and `onChange` props, so
  // these two names cannot be renamed.
  value?: UploadFile[];
  onChange?: (value: UploadFile[]) => void;
}) => {
  const { handleOpen } = useDocumentPreviewModalDeprecated();

  const triggerChange = useCallback(
    (change: UploadChangeParam) => {
      onChange?.(change.fileList);
    },
    [onChange]
  );

  return (
    <div className="wk-inline-file-uploader-input">
      <Upload
        name="files"
        beforeUpload={() => false}
        defaultFileList={value}
        multiple={multiple}
        onChange={triggerChange}
        onPreview={(file) => {
          if (file.originFileObj) {
            handleOpen({ kind: 'uploadFile', data: file });
          } else if (file.response?.downloadUrl) {
            handleOpen({ kind: 'uploadedFile', data: file.response });
          }
        }}
      >
        <span className="upload-link">
          <b>Attach a File</b>
        </span>{' '}
        {instruction}
      </Upload>
      <style jsx>
        {`
          .wk-inline-file-uploader-input {
            max-width: 100%;
          }
          .wk-inline-file-uploader-input :global(.ant-upload-list-item-name) {
            color: ${Colors.elm};
            cursor: pointer;
          }
          .wk-inline-file-uploader-input :global(.errors-container) {
            margin-top: 8px;
          }
          .wk-inline-file-uploader-input :global(.upload-link) {
            color: ${Colors.elm};
            cursor: pointer;
          }
        `}
      </style>
    </div>
  );
};
